export const lendersRoutes = [
    {
        path:"/lenders",
        name: 'Lenders', 
        component: () => import('./Index.vue'),
        meta: {requiresAuth: true},
        redirect: {
            name: "Lenders.Overview"
        },
        children: [
            {
                path:'overview',
                name: 'Lenders.Overview',
                component: () => import('./Overview.vue'),
            },
            {
                path:'add_lender',
                name: 'Lenders.AddLender',
                component: () => import('./AddLender.vue'),
            }
        ]
    },
]